import {defaultOptions} from '../lib/locale';
import {byId} from './util';

const initialState = {
  byId: {}
};

const defaultFolderOptions = Object.freeze(Object.assign(
  {nsfw: 'moderate'},
  defaultOptions()
));

export function folders(state = initialState, action) {
  switch (action.type) {
  case 'FOLDER_RECEIVE': {
    const folder = Object.assign({}, action.payload);

    /* eslint-disable guard-for-in */
    for (const optionKey in defaultFolderOptions) {
      const optionValue = folder.options[optionKey];

      if (optionValue === undefined || optionValue === '') {
        folder.options[optionKey] = defaultFolderOptions[optionKey];
      }
    }
    /* eslint-enable guard-for-in */

    return byId(state, folder);
  }
  default:
    return state;
  }
}
